import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { saveCustomRequest } from '../services/customRequest.service';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        subject: '',
        message: ''
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const validate = () => {
        const newErrors = {};
        
        // Name validation
        if (!formData.name.trim()) {
            newErrors.name = "Full name is required";
        } else if (formData.name.trim().length < 3) {
            newErrors.name = "Name must be at least 3 characters";
        }


        // Phone validation (10 digits)
        const phoneRegex = /^[0-9]{10}$/;
        if (!formData.phone) {
            newErrors.phone = "Phone number is required";
        } else if (!phoneRegex.test(formData.phone)) {
            newErrors.phone = "Please enter a valid 10-digit phone number";
        }

        // Subject validation
        if (!formData.subject.trim()) {
            newErrors.subject = "Subject is required";
        }

        // Message validation
        if (!formData.message.trim()) {
            newErrors.message = "Message is required";
        } else if (formData.message.trim().length < 10) {
            newErrors.message = "Message must be at least 10 characters";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
        // Clear error when user starts typing
        if (errors[id]) {
            setErrors({ ...errors, [id]: null });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validate()) {
            return;
        }

        setLoading(true);
        try {
            await saveCustomRequest(formData);
            alert("Your request has been submitted successfully!");
            setFormData({ name: '', phone: '', subject: '', message: '' });
        } catch (error) {
            alert("Error submitting request. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="contact py-80">
            <div className="container container-lg">
                <div className="row gy-5">
                    <div className="col-lg-8">
                        <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                            <form onSubmit={handleSubmit}>
                                <h6 className="mb-32">Contact Us</h6>
                                <div className="row gy-4">
                                    <div className="col-sm-6 col-xs-6">
                                        <label
                                            htmlFor="name"
                                            className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                        >
                                            Full Name{" "}
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        <input
                                             type="text"
                                             className={`common-input px-16 ${errors.name ? 'border-danger-600' : ''}`}
                                             id="name"
                                             placeholder="Full name"
                                             value={formData.name}
                                             onChange={handleChange}
                                             required
                                         />
                                         {errors.name && <span className="text-danger-600 text-xs mt-4 d-block">{errors.name}</span>}
                                     </div>
                                     <div className="col-sm-6 col-xs-6">
                                         <label
                                             htmlFor="phone"
                                             className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                         >
                                             Phone Number
                                             <span className="text-danger text-xl line-height-1">*</span>{" "}
                                         </label>
                                         <input
                                             type="number"
                                             className={`common-input px-16 ${errors.phone ? 'border-danger-600' : ''}`}
                                             id="phone"
                                             placeholder="Phone Number*"
                                             value={formData.phone}
                                             onChange={handleChange}
                                             required
                                         />
                                         {errors.phone && <span className="text-danger-600 text-xs mt-4 d-block">{errors.phone}</span>}
                                     </div>
                                     <div className="col-sm-6 col-xs-6">
                                         <label
                                             htmlFor="subject"
                                             className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                         >
                                             Subject
                                             <span className="text-danger text-xl line-height-1">
                                                 *
                                             </span>{" "}
                                         </label>
                                         <input
                                             type="text"
                                             className={`common-input px-16 ${errors.subject ? 'border-danger-600' : ''}`}
                                             id="subject"
                                             placeholder="Subject"
                                             value={formData.subject}
                                             onChange={handleChange}
                                             required
                                         />
                                         {errors.subject && <span className="text-danger-600 text-xs mt-4 d-block">{errors.subject}</span>}
                                     </div>
                                     <div className="col-sm-12">
                                         <label
                                             htmlFor="message"
                                             className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                        >
                                            Message
                                            <span className="text-danger text-xl line-height-1">
                                                *
                                            </span>{" "}
                                        </label>
                                        <textarea
                                            className={`common-input px-16 ${errors.message ? 'border-danger-600' : ''}`}
                                            id="message"
                                            placeholder="Type your message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.message && <span className="text-danger-600 text-xs mt-4 d-block">{errors.message}</span>}
                                    </div>
                                    <div className="col-sm-12 mt-32 d-flex justify-content-center">
                                        <button
                                            type="submit"
                                            className="btn btn-main py-18 px-32 rounded-pill"
                                            disabled={loading}
                                        >
                                            {loading ? "SUBMITTING..." : "SUBMIT"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                            <h6 className="mb-48">Get In Touch</h6>
                            <div className="flex-align gap-16 mb-16">
                                <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-phone-call" />
                                </span>
                                <Link
                                    to="tel:9940075399"
                                    className="text-md text-gray-900 hover-text-main-600"
                                >
                                    9940075399
                                </Link>
                            </div>
                            <div className="flex-align gap-16 mb-16">
                                <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-envelope" />
                                </span>
                                <Link
                                    to="mailto:culturevedhas@gmail.com"
                                    className="text-md text-gray-900 hover-text-main-600"
                                >
                                    culturevedhas@gmail.com
                                </Link>
                            </div>
                            <div className="flex-align gap-16 mb-0">
                                <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-map-pin" />
                                </span>
                                <span className="text-md text-gray-900 ">
                                    123,Sakthinagar 4th cross left, Sengodampallam, Thindal, Erode - 638012
                                </span>
                            </div>
                        </div>
                        <div className="mt-24 flex-align flex-wrap gap-16">
                            <Link
                                to="tel:9940075399"
                                className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
                            >
                                <span className="text-white fw-medium">Get Support On Call</span>
                                <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                                    <i className="ph ph-headset" />
                                </span>
                            </Link>
                            <Link
                                to="https://maps.google.com/?q=11.322122,77.685051"
                                target="_blank"
                                className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
                            >
                                <span className="text-white fw-medium">Get Direction</span>
                                <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                                    <i className="ph ph-map-pin" />
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
                
                {/* Google Map Integration */}
                <div className="row mt-80">
                    <div className="col-12">
                        <div className="contact-map rounded-16 overflow-hidden border border-gray-100 shadow-sm">
                            <iframe 
                                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3912.7625!2d77.685051!3d11.322122!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTHCsDE5JzE5LjYiTiA3N8KwNDEnMDYuMiJF!5e0!3m2!1sen!2sin!4v1714972800000!5m2!1sen!2sin" 
                                width="100%" 
                                height="450" 
                                style={{ border: 0 }} 
                                allowFullScreen="" 
                                loading="lazy" 
                                referrerPolicy="no-referrer-when-downgrade"
                                title="VedhaCultures Location"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Contact